module.exports = __webpack_public_path__ + "img/Screenshot-2023-12-23-142209-e17.e40ef9d2.png";